import { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import styles from "./cartaoColaborador.module.css";
import { AuthContext } from "../../context/AuthContext";
import api from "../../services/api";
import BottomNav from "../../components/BottomNav";
import RodapePrincipios from "../../assets/principios-cozimax.png";

function formatarDataHora(data) {
    const dia = String(data.getDate()).padStart(2, "0");
    const mes = String(data.getMonth() + 1).padStart(2, "0");
    const ano = data.getFullYear();
    const hora = String(data.getHours()).padStart(2, "0");
    const min = String(data.getMinutes()).padStart(2, "0");
    return `${dia}/${mes}/${ano} | às ${hora}h${min}m`;
}

// datadi pode vir como "dd/mm/yyyy" (já formatado) ou ISO/"yyyy-mm-dd..."
// (serialização padrão de TDateTime do FireDAC). Extrai os componentes direto
// da string via regex em vez de passar por `new Date()` - uma data "yyyy-mm-dd"
// sem horário é interpretada como UTC meia-noite, e em fuso negativo (Brasil)
// isso pode voltar um dia (vira 13 em vez de 14) depois de converter pro
// horário local - mesmo cuidado já tomado com datas de comunicado.
function formatarDataAdmissao(valor) {
    if (!valor) return "—";
    const br = valor.match(/^(\d{2})\/(\d{2})\/(\d{4})/);
    if (br) return `${br[1]}/${br[2]}/${br[3]}`;
    const iso = valor.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (iso) return `${iso[3]}/${iso[2]}/${iso[1]}`;
    return valor;
}

// Normaliza pra minúsculo, igual ao padrão já usado em MenuContext.jsx (o
// ToJSONArray/ToJSONObject do FireDAC devolve os campos em minúsculo, não no
// "case" do alias da SQL original).
function lc(obj) {
    if (!obj) return {};
    return Object.fromEntries(Object.entries(obj).map(([k, v]) => [k.toLowerCase(), v]));
}

export default function CartaoColaborador() {
    // Título/ícone/subtítulo do header vêm do próprio item de menu (label,
    // icone, subtitulo cadastrados no CozimaxERP), passados via state da
    // navegação - mesmo mecanismo já usado pros itens tipo 'conteudo' (ver
    // MenuConteudo.jsx e LayoutBase.jsx/handleItemClick). Fallback só cobre
    // acesso direto à rota sem passar pelo menu (ex: refresh da página).
    const { state } = useLocation();
    const titulo = state?.titulo || "Cartão do Colaborador";
    const icone = state?.icone || "🪪";
    const subtitulo = state?.subtitulo || "Sua identificação Cozimaxer";

    const { user } = useContext(AuthContext);

    // tipfun 'F' = funcionário CLT (fpd025), 'T' = terceiro/PJ (fpd925) -
    // mesma distinção já usada em Informacoes/PLR (pedido do usuário,
    // 2026-10-20): CLT continua "Eu sou Cozimaxer!", PJ passa a ser
    // "Sou Prestador Cozimaxer!".
    const ehPrestador = user?.tipfun === 'T';

    const [foto, setFoto] = useState(() => localStorage.getItem("fotoFuncionario"));
    const [dados, setDados] = useState({});
    const [consultaEm] = useState(() => formatarDataHora(new Date()));

    useEffect(() => {
        if (foto) return;
        api.get(`/colaborador/getfoto/?codfun=${user.codfun}&tipfun=${user.tipfun}`)
            .then(res => {
                localStorage.setItem("fotoFuncionario", res.data.fotfun);
                setFoto(res.data.fotfun);
            })
            .catch(() => { });
    }, []);

    useEffect(() => {
        api.get(`/colaborador/dados/?codfun=${user.codfun}&tipfun=${user.tipfun}`)
            .then(res => setDados(lc(res.data)))
            .catch(() => { });
    }, []);

    // Data de admissão: campo datadi (confirmado pelo usuário, 2026-10-07).
    // Empresa/CNPJ são fixos neste cartão - não variam por colaborador.
    const dataAdmissao = formatarDataAdmissao(dados.datadi);
    const nomeEmpresa = "COZIMAX MÓVEIS";
    const cnpjEmpresa = "02.043.201/0001-00";

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <span className={styles.headerIcon}>{icone}</span>
                <div className={styles.headerTexto}>
                    <h2>{titulo}</h2>
                    <p>{subtitulo}</p>
                </div>
            </div>

            <div className={styles.cartao}>
                <h1 className={`${styles.titulo} ${ehPrestador ? styles.tituloPrestador : ""}`}>
                    {ehPrestador ? "Sou Prestador " : "Eu sou "}
                    <span className={styles.tituloCozimaxer}>
                        <span className={styles.tituloDestaque}>
                            Coz<span className={styles.letraI}>ı<span className={styles.tituloPonto} /></span>
                        </span>
                        <span className={styles.tituloResto}>maxer!</span>
                    </span>
                </h1>

                <div className={styles.fotoWrap}>
                    {foto ? (
                        <img src={`data:image/jpeg;base64,${foto}`} alt="Foto do colaborador" className={styles.foto} />
                    ) : (
                        <div className={styles.fotoPlaceholder}>{user?.nomfun?.charAt(0)}</div>
                    )}
                </div>

                <h2 className={styles.nome}>{user?.nomfun}</h2>

                <div className={styles.bloco}>
                    <span className={styles.label}>Desde:</span>
                    <span className={styles.valorGrande}>{dataAdmissao}</span>
                </div>

                <div className={styles.empresa}>
                    <span className={styles.empresaNome}>{nomeEmpresa}</span>
                    <span className={styles.empresaCnpj}>CNPJ: {cnpjEmpresa}</span>
                </div>

                <div>
                    <span className={styles.label}>Consulta realizada em:</span>
                    <span className={styles.consultaValor}>{consultaEm}</span>
                </div>
            </div>

            <img src={RodapePrincipios} alt="Princípios Cozimax" className={styles.rodapeImagem} />

            <BottomNav />
        </div>
    );
}
